import styled from "styled-components";

export const CopyForecastButtonContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-bottom: 16px;
    margin-top: -8px;
    @media (max-width: 768px) {
        width: 100%;
        justify-content: flex-start;
        margin-bottom: 0px;

        button {
            width: 100%;
        }
    }
`;
